import React from "react";
import { Parallax } from "react-scroll-parallax";
import { motion } from "framer-motion";
import "./About.css";
import ReusableCard from "../components/ReusableCard/ReusableCard";

import aboutBinkley from "../assets/blockstock.webp"

function About() {
  const cards = [
    { title: "Our Mission & Philosophy", speed: -5, link: "/about/mission" },
    { title: "Binkley's Curriculum", speed: -5, link: "/about/curriculum" },
    { title: "Tuition & Scholarships", speed: -6, link: "/about/tuition" },
  ];

  return (
    <main role="main" className="about-container">
      {/* Hero Section with Parallax background */}
      <Parallax speed={-10} className="about-content" aria-hidden="true">
        <div className="about-images">
          <img 
            src={aboutBinkley} 
            alt="Generations of Binkley students and families" 
            className="about-bg" 
            loading="lazy" 
          />
        </div>

        <div className="about-blurb">
          <h1>What is Binkley all about?</h1>
          <p>
            In the fall of 1965, Binkley Kindergarten was established as an outreach ministry of Olin T. Binkley Baptist Church.
          </p>
          <p>
            The school was created with a community mission in mind: providing quality preschool opportunities for children of all backgrounds – ethnic, cultural, or socio-economic.
          </p>
          <p>
            At Binkley Preschool, we believe children learn best through play. We strive to foster a loving, nurturing environment that is stimulating and age-appropriate, giving preschoolers a solid foundation for their education.
          </p>
          <p>
            What started as a kindergarten program has grown into a multi-age preschool program. Even after over 60 years, we still uphold the goals of our founders!
          </p>
        </div>
      </Parallax>

      {/* Cards Section */}
      <section className="about-cards-section">
        <h2 className="about-cards-header">Click below to learn more!</h2>

        <motion.div
          className="about-grid"
          role="list"
          initial="hidden"
          animate="visible"
          variants={{ visible: { transition: { staggerChildren: 0.1 } } }}
        >
          {cards.map(({ title, speed, link }, index) => (
            <Parallax key={index} speed={speed} aria-hidden="true">
              <ReusableCard title={title} link={link} role="listitem" />
            </Parallax>
          ))}
        </motion.div>
      </section>
    </main>
  );
}

export default About;
